import { css, html } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { when } from "lit-html/directives/when.js";
import { query } from "lit/decorators.js";
import "../../atom/Icon/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { getClasses, getDotClasses } from "./utils.js";
import { defineElement } from "../../../decorators/defineElement.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfBadge = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_level = "default";
    this.dsf_square = false;
    this.dsf_size = "medium";
    this.dsf_dot_status = false;
  }
  get isOnlyIconElement() {
    var _a;
    return ((_a = this.textContent) == null ? void 0 : _a.trim().length) === 0 && !!this.dsf_icon_left;
  }
  render() {
    const classes = getClasses(this);
    const dotClasses = getDotClasses(this);
    const leftIcon = when(
      this.dsf_icon_left,
      () => html`<dsf-icon dsf_name="${ifDefined(this.dsf_icon_left)}" class="h-12 w-12"></dsf-icon>`
    );
    const dotStatus = when(this.dsf_dot_status, () => html`<div class="${dotClasses}"></div>`);
    return html`<span class="${classes}" part="badge" data-skeleton>
      ${leftIcon || dotStatus}
      <div class=${`truncate ${this.isOnlyIconElement ? "hidden" : ""}`}>
        <slot></slot>
      </div>
    </span>`;
  }
};
DsfBadge.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: inline-flex;
      }
    `
];
__decorateClass([
  prop({ type: String, reflect: true })
], DsfBadge.prototype, "dsf_level", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfBadge.prototype, "dsf_square", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfBadge.prototype, "dsf_icon_left", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfBadge.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfBadge.prototype, "dsf_dot_status", 2);
__decorateClass([
  query("slot")
], DsfBadge.prototype, "textSlotElement", 2);
DsfBadge = __decorateClass([
  defineElement("dsf-badge")
], DsfBadge);
export {
  DsfBadge
};
